import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { startTimeSync } from './time-sync';

// Block first paint on initial client/server clock sync (~50-150ms on
// most networks). Otherwise live-clock hooks would render against a
// raw Date.now() for the first ~100ms, producing visible drift if the
// user's machine clock is off — exactly the symptom that led to this.
startTimeSync().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
